
//:key="$route.fullPath"
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class policies extends Vue {
  name: String = "policies";
}
